import { render, staticRenderFns } from "./ShowPoint.vue?vue&type=template&id=12879b3e&"
import script from "./ShowPoint.vue?vue&type=script&lang=js&"
export * from "./ShowPoint.vue?vue&type=script&lang=js&"
import style0 from "./ShowPoint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports